module.exports = __webpack_public_path__ + "static/media/banner3.387c28c6.png";